import styled from "styled-components";

export const StyledSection2 = styled.div`
  .section2-container {
    padding-top: 32px;
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    gap: 32px;
  }
`;
